<template>
    <v-dialog v-model="dialogSwitch" persistent scrollable width="700">
        <v-card>
            <v-card-title id="heading" class="bg-white position-fixed w-100 z-index-9">
                <div class="d-flex justify-space-between">
                    <h4>{{ role.title }} Menu Groups</h4>
                    <v-btn density="compact" icon="mdi-close" variant="flat" @click="$emit('update:modelValue',false)"/>
                </div>
            </v-card-title>

            <v-container class="mt-10 mb-5">
                <v-alert v-if="errors.length" class="mb-3 bg-error" closable close-label="Close Alert"
                         density="compact" variant="tonal">
                    <p v-for="error in errors">{{ error }}</p>
                </v-alert>

                <v-row>
                    <v-col v-for="menuGroup in menuGroups" class="py-0" cols="4">
                        <v-switch v-model="assignedMenuGroupIds" :label="`${menuGroup.title}`"
                                  :value="menuGroup.id"
                                  color="primary"
                                  density="compact"/>
                    </v-col>
                </v-row>
            </v-container>

            <v-card-actions class="px-4 bg-white position-fixed w-100 z-index-9 bottom-0">
                <div class="d-flex justify-end">
                    <v-btn :disabled="!assignedMenuGroupIds.length" color="primary" size="small"
                           @click="updateMenuGroups">
                        Save
                    </v-btn>
                    <v-btn size="small" type="button"
                           @click="$emit('update:modelValue',false)">
                        Close
                    </v-btn>
                </div>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script setup>
import {ref, onMounted} from "vue";
import {send} from "@/composables/apiClient";
import {useSnackbarStore} from "@/stores/snackBarStore";

const {showSnackbar} = useSnackbarStore();
const props = defineProps({
    modelValue: Boolean,
    role: {
        type: Object
    }
});

const emits = defineEmits(['update:modelValue']);
const dialogSwitch = ref(props.modelValue);
const assignedMenuGroupIds = ref([]);
const assignedMenuGroups = ref([]);
const menuGroups = ref([]);
const errors = ref([]);

onMounted(() => {
    fetchMenuGroups();
    fetchAssignedMenuGroups();
});

const fetchMenuGroups = () => {
    send('get', `admin/menu-groups`, {list: true, type: props.role.role_type})
        .then((response) => {
            menuGroups.value = response.data.data;
        })
        .catch((error) => {
            console.log(error)
            showSnackbar('Roles could not be loaded', 'error')
        })
}

const fetchAssignedMenuGroups = () => {
    send('get', `admin/roles/menu-groups?role=${props.role.id}`)
        .then((response) => {
            assignedMenuGroups.value = response.data.data;
            if (assignedMenuGroups.value.length) {
                assignedMenuGroups.value.map((menuGroup) => {
                    assignedMenuGroupIds.value.push(menuGroup.id);
                })
                console.log(assignedMenuGroupIds.value)
            }
        })
        .catch((error) => {
            console.log(error)
            showSnackbar('Menu groups could not be loaded', 'error')
        })
}
const updateMenuGroups = () => {
    errors.value = [];
    send('post', `admin/roles/menu-groups`, {role: props.role.id, menuGroups: assignedMenuGroupIds.value})
        .then((response) => {
            showSnackbar(response.data.message);
            if (response.data.success) {
                emits('update:modelValue', false);
            }
        })
        .catch(function (errorResponse) {
            if (errorResponse.response.data.errors) {
                let validationErrors = errorResponse.response.data.errors;
                Object.keys(validationErrors).forEach((key) => {
                    errors.value.push(validationErrors[key][0]);
                });
            } else if (errorResponse.response.data.message) {
                errors.value.push(errorResponse.response.data.message);
            }
            showSnackbar('Something went wrong', 'error');
            document.getElementById('heading').scrollIntoView({behavior: 'smooth'});
        })
}

</script>

<style scoped>
.z-index-9 {
    z-index: 9;
}
</style>
